import { render, staticRenderFns } from "./departmentForm.vue?vue&type=template&id=75682573&scoped=true&"
import script from "./departmentForm.vue?vue&type=script&lang=js&"
export * from "./departmentForm.vue?vue&type=script&lang=js&"
import style0 from "./departmentForm.vue?vue&type=style&index=0&id=75682573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75682573",
  null
  
)

export default component.exports